var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-xs-6 form-group"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('Typeahead',{ref:"model",attrs:{"cdi_type":_vm.cdiType,"placeholder":''},on:{"objectSelected":(data) => _vm.$emit('update', data)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }